"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = RadioGroup;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _Radio = require("./Radio");

var _Field = require("./Field");

var _excluded = ["disabled", "errorMessage", "isValid", "label", "options", "orientation"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ORIENTATIONS = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};

function RadioGroup(props) {
  var disabled = props.disabled,
      errorMessage = props.errorMessage,
      isValid = props.isValid,
      label = props.label,
      options = props.options,
      orientation = props.orientation,
      remainingProps = _objectWithoutProperties(props, _excluded);

  return (
    /*#__PURE__*/
    _react["default"].createElement(_Field.Field, {
      label: label,
      isValid: isValid,
      errorMessage: errorMessage,
      disabled: disabled
    },
    /*#__PURE__*/
    _react["default"].createElement(_RadioGroup["default"], _extends({
      row: orientation === ORIENTATIONS.horizontal
    }, remainingProps), options.map(function (option) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_Radio.Radio, {
          key: option.valueField,
          disabled: props.disabled,
          label: option.textField,
          value: option.valueField
        })
      );
    })))
  );
}

RadioGroup.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    textField: _propTypes["default"].string,
    valueField: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  })).isRequired,
  disabled: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  isValid: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
RadioGroup.defaultProps = {
  disabled: false,
  errorMessage: '',
  isValid: true,
  label: '',
  orientation: 'horizontal',
  value: null
};